enum RoleEnum {
  super_admin = 1,
  super_support = 2,
  tagrani_admin = 3,
  tagrani_support = 4,
  tagrani_user = 5,
  bookero_admin = 6,
  bookero_support = 7,
  bookero_user = 8,
  whitelabel_support = 9,
  end_user = 10,
}

export default RoleEnum;
